module.exports = __webpack_public_path__ + "static/img/banner-cursos-home-1024x768.a93dfed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-cursos-home-1024x768.jpg
// module id = cqal
// module chunks = 47